import React from "react";

function AddOfflineBooking() {
  return (
    <div className="container" style={{ padding: "20px", marginTop: "35px" }}>
      <h5 className="heading-title mt-4">Add Offline Bookings</h5>

      <div className="row">
        <div className="col-md-4">
          <div className="card border-1 shadow-sm mb-3 p-2 rounded-3 overflow-hidden">
            <input
              type="text"
              className="form-control form-control-sm mb-2"
              placeholder="Pickup Location"
            />
            <input
              type="text"
              className="form-control form-control-sm mb-2"
              placeholder="Drop Location"
            />
            <input
              type="text"
              className="form-control form-control-sm mb-2"
              placeholder="Customer Name"
            />
          </div>
        </div>
        <div className="col-md-4"></div>
        <div className="col-md-4"></div>
      </div>
    </div>
  );
}

export default AddOfflineBooking;
